// Piano scelto in registrazione, conservato fino alla creazione della famiglia (sopravvive a login Google / conferma email)
const KEY = 'curacheck_pending_plan';

export const CHECKOUT_FIRST_PLANS = ['standard', 'premium', 'fondatori', 'founder'];

export const savePendingPlan = (plan, billingPeriod) => {
  if (plan && plan !== 'base') localStorage.setItem(KEY, JSON.stringify({ plan, billingPeriod: billingPeriod || 'monthly' }));
  else localStorage.removeItem(KEY);
};

export const readPendingPlan = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || null;
  } catch (e) {
    return null;
  }
};

export const clearPendingPlan = () => localStorage.removeItem(KEY);
